import React, {FC, useState} from "react"

import {walletTracking} from "@irati-tracking/wallet"
import {Deal} from "@irati/types"
import EarnPoints from "@irati/ui/images/EarnPoints.svg"
import FlexiPointsIcon from "@irati/ui/images/flexi_point.svg"
import {FormattedMessage} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Label} from "@irati/ui/src/Typography"

/* eslint-disable no-restricted-imports */
/** @description: why can't we import auth helper in ui package? */
import authentication from "@irati/auth"

import EarnPointsModalContent from "./EarnPointsModalContent"
import {HeroText, SecondaryText, StyledLabel, Wrapper, Image} from "./styled"
import TooltipText from "./TooltipText"
import {OverlayPlacement, Tooltip} from "@irati/ui/src/Tooltip"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"

interface Props {
  deal: Deal
  hasModal?: boolean
  newDesign?: boolean
}

const EarnPointsBadge: FC<Props> = ({deal, hasModal, newDesign}) => {
  const [showModal, setShowModal] = useState(false)
  const hasFpWallet = authentication.apps("wallet.treatTokens")

  if (!hasFpWallet || !deal.earnPoints) {
    return null
  }

  const handleModal = () => {
    if (!hasModal) {
      return
    }
    if (!showModal) {
      // fire tracking just when opening modal
      walletTracking.viewEarnPointsModal()
    }
    setShowModal(!showModal)
  }

  const TooltipChildren = <TooltipText id="earnToolTip" />

  const handleOnEnter = () => {
    const isPerksInfo = window.location.href.includes("perks/info")
    walletTracking.viewEarnPointsTooltip({isPerksInfo})
  }

  return (
    <>
      <Tooltip tooltipChildren={TooltipChildren} placement={OverlayPlacement.Bottom} onEntered={handleOnEnter}>
        <Flex alignItems="center" onClick={handleModal} marginLeft={newDesign ? -0.5 : 0}>
          {newDesign ? (
            <>
              <Icon icon={IconTypes.flexiPoints} />
              <Flex marginLeft={0.5} direction="column">
                <StyledLabel small>
                  <FormattedMessage id="platform.earnPoints.component.earn" />
                </StyledLabel>
                <StyledLabel small bold>
                  <FormattedMessage id="platform.earnPoints.component.points" />
                </StyledLabel>
              </Flex>
            </>
          ) : (
            <>
              <Wrapper id={deal.uuid} hasModal={hasModal} direction="column" alignItems="center" padding={1}>
                <Image src={FlexiPointsIcon} />
                <HeroText>
                  <FormattedMessage id="platform.earnPoints.component.earn" />
                </HeroText>
                <SecondaryText>
                  <FormattedMessage id="platform.earnPoints.component.points" />
                </SecondaryText>
              </Wrapper>
              <Label small marginLeft marginRight>
                <FormattedMessage id="platform.earnPoints.component.or" />
              </Label>
            </>
          )}
        </Flex>
      </Tooltip>
      <GenericModal id="earnModalId" show={showModal} onHide={handleModal} hideActions image={EarnPoints}>
        <EarnPointsModalContent onCTAClick={handleModal} />
      </GenericModal>
    </>
  )
}

export default EarnPointsBadge
